export class ApiError extends Error {}

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  // 本文がないリクエストにContent-Type: application/jsonを付けると、
  // Fastifyのデフォルトパーサーが「JSONのはずなのに空」とエラーを返す
  // （FST_ERR_CTP_EMPTY_JSON_BODY）ため、本文がある場合のみ付与する。
  const response = await fetch(`/api${path}`, {
    ...options,
    credentials: "include",
    headers: {
      ...(options.body !== undefined ? { "Content-Type": "application/json" } : {}),
      ...(options.headers ?? {}),
    },
  });

  if (response.status === 204) {
    return undefined as T;
  }

  const contentType = response.headers.get("content-type") ?? "";
  const isJson = contentType.includes("application/json");
  const body: unknown = isJson ? await response.json() : await response.text();

  if (!response.ok) {
    const message =
      isJson && body && typeof body === "object" && "error" in body
        ? String((body as { error: string }).error)
        : "通信エラーが発生しました。ネットワーク状態を確認してください。";
    throw new ApiError(message);
  }

  return body as T;
}

export const apiClient = {
  get: <T>(path: string): Promise<T> => request<T>(path),
  post: <T>(path: string, data?: unknown): Promise<T> =>
    request<T>(path, { method: "POST", body: data !== undefined ? JSON.stringify(data) : undefined }),
  put: <T>(path: string, data?: unknown): Promise<T> =>
    request<T>(path, { method: "PUT", body: data !== undefined ? JSON.stringify(data) : undefined }),
  delete: <T>(path: string): Promise<T> => request<T>(path, { method: "DELETE" }),
};
